import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import { useSearchParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import axios from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import { Box } from "@mantine/core";
import { IconDownload, IconEye } from "@tabler/icons-react";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import Pagination from "rc-pagination";
import { CircularProgress, debounce } from "@material-ui/core";
import { toast } from "react-toastify";
const useStyles = makeStyles(styles);
export default function SoldTicketsTable() {
  const [soldTableData, setSoldTableData] = useState([]);
  console.log(soldTableData, "soldTableData")
  const [paginationData, setPaginationData] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");
  console.log(searchText, "searchText")
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  console.log(debouncedSearchText, "debouncedSearchText")
  const classes = useStyles();
  const [searchParams] = useSearchParams();
  const lotteryId = searchParams.get("LotteryId");
  const [loadingDownload, setLoadingDownload] = useState(false);
  const columns = useMemo(() => [

    {
      header: "Transaction Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Price",
      accessorKey: "price",
      size: 10,
    },
    {
      header: "Ticket Number",
      accessorKey: "ticketNumber",
      size: 10,
    },
    {
      header: "User name",
      accessorKey: "userName",
      size: 10,
    },
    {
      header: "Jackpot Color",
      accessorKey: "colorNameforJackpot",
      size: 10,
    },
    {
      header: "Status",
      accessorKey: "lotteryStatus",
      size: 10,
    },
  ]);

  useEffect(() => {
    getData(page, limit, lotteryId, debouncedSearchText);
  }, [debouncedSearchText, page, limit, lotteryId]);

  const getData = async (page = 1, limit = 10, lotteryId = "", search) => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/soldTicketLogs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page,
            limit,
            lotteryId,
            search: search
          },
        }
      );


      setSoldTableData(response.data);
      setPaginationData(response?.data?.metadata);

    } catch (err) {
      console.error("Error fetching winner logs:", err);

      if (
        err?.response?.data?.message ===
        "For security reasons, we locked your account.Please login to continue"
      ) {
        localStorage.removeItem("token");
        window.location.assign("/auth/login-page");
      }
    } finally {
      setLoading(false);
    }
  };

  const updatePage = (newPage) => {
    setPage(newPage);
  };
  const debouncedSearch = useMemo(() => debounce((value) => {
    setDebouncedSearchText(value);
    if (value === "") {
      setPage(1);
      setLimit(10);
    }
  }, 500), []);
  const handleDownload = async () => {
    if (!lotteryId) {
      console.error("Lottery ID is required for download.");
      return;
    }
    setLoadingDownload(true);
    console.log("Downloading logs for lottery ID:");
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/soldTicketLogsDownload`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
        params: {
          lotteryId,
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Sold_Ticket_Logs_List.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
       if (error?.response?.status === 403) {
        toast.error("You do not have permission to download this file.");
        return;
      } else {
        swal.fire({
          icon: "error",
          text: "error",
        });
      }
    } finally {
      setLoadingDownload(false); // hide loader
    }
  }
  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Sold Ticket Logs Table</h4>

            </CardHeader>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <CardBody>
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    flexWrap: "wrap",
                    padding: "16px",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "6px 12px",
                      width: "300px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                      search
                    </i>
                    <input
                      type="text"
                      value={searchText}
                      placeholder="Search by lottery name or ID"
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        debouncedSearch(e.target.value);
                      }}
                      style={{
                        border: "none",
                        outline: "none",
                        width: "100%",
                        fontSize: "14px",
                      }}
                    />

                  </Box>
                  {loadingDownload ? (
                 
                      <CircularProgress size={24} style={{ color: "black" }} />
                
                  ) : (
                    <Button
                      onClick={handleDownload}
                      style={{ marginLeft: "auto" }}
                      leftIcon={<IconDownload />}
                    >
                      Export All Rows
                    </Button>
                  )}

                </Box>
                {soldTableData?.data?.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    {soldTableData?.message}
                  </Box>
                ) : (
                  <>
                    <MantineReactTable
                      columns={columns}
                      enableRowNumbers
                      positionActionsColumn="first"
                      displayColumnDefOptions={{
                        "mrt-row-actions": {
                          mantineTableHeadCellProps: {
                            align: "center",
                          },
                          size: 120,
                        },
                      }}
                      data={soldTableData?.data || []}
                      enableColumnFilters={false}
                      enableColumnFilterModes={false}
                      enableGlobalFilter={false}
                      enableFilters={false}
                      enableFullScreenToggle={false}
                      enableDensityToggle={false}
                      enableHiding={false}
                      enableColumnResizing={false}
                      enableColumnOrdering={false}
                      initialState={{ showColumnFilters: true }}
                      positionToolbarAlertBanner="bottom"
                      enablePagination={false}


                    />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "20px",
                      }}
                    >
                      <Pagination
                        pageSize={paginationData?.pageSize || 10}
                        current={paginationData?.currentPage || 1}
                        total={paginationData?.totalCount || 0}
                        onChange={updatePage}
                      />
                    </Box>
                  </>
                )}
              </CardBody>
            )}
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
